<template>
  <header class="header">
    <div class="header-content">
      <div class="logo" @click="homeClicked" title="Click and Plan God">
        <img src="@/assets/images/logo_header.png" alt="Click and Plan Logo" />
      </div>

      <nav class="header_icons_container" aria-label="Navegación principal">
        <button
          class="nav-item"
          :class="{ 'is-active': isActive('/home') }"
          @click="homeClicked"
          title="Inicio"
        >
          <div class="icon-circle">
            <img src="@/assets/images/home_icon_off.png" alt="Inicio" class="header_icon" />
          </div>
          <span class="nav-label">Inicio</span>
        </button>

        <button
          class="nav-item"
          :class="{ 'is-active': isActive('/users') }"
          @click="usersClicked"
          title="Usuarios"
        >
          <div class="icon-circle">
            <img src="@/assets/images/users_icon_off.png" alt="Usuarios" class="header_icon" />
          </div>
          <span class="nav-label">Usuarios</span>
        </button>

        <button
          class="nav-item"
          :class="{ 'is-active': isActive('/plans') }"
          @click="plansClicked"
          title="Planes"
        >
          <div class="icon-circle">
            <img src="@/assets/images/plans_icon_off.png" alt="Planes" class="header_icon" />
          </div>
          <span class="nav-label">Planes</span>
        </button>

        <button
          class="nav-item"
          :class="{ 'is-active': isActive('/reservations') }"
          @click="reservationsClicked"
          title="Reservas"
        >
          <div class="icon-circle">
            <img src="@/assets/images/reservations_icon_off.png" alt="Reservas" class="header_icon" />
          </div>
          <span class="nav-label">Reservas</span>
        </button>

        <button
          class="nav-item"
          :class="{ 'is-active': isActive('/privateplans') }"
          @click="privateplansClicked"
          title="Planes Privados"
        >
          <div class="icon-circle">
            <img src="@/assets/images/privateplans_icon_off.png" alt="Planes Privados" class="header_icon" />
          </div>
          <span class="nav-label">Privados</span>
        </button>

        <button
          class="nav-item"
          :class="{ 'is-active': isActive('/wallet') }"
          @click="walletClicked"
          title="Monedero"
        >
          <div class="icon-circle">
            <img src="@/assets/images/wallet_icon_off.png" alt="Monedero" class="header_icon" />
          </div>
          <span class="nav-label">Monedero</span>
        </button>

        <button
          class="nav-item"
          :class="{ 'is-active': isActive('/coupons') }"
          @click="couponsClicked"
          title="Cupones"
        >
          <div class="icon-circle">
            <img src="@/assets/images/coupons_icon_off.png" alt="Cupones" class="header_icon" />
          </div>
          <span class="nav-label">Cupones</span>
        </button>

        <button
          class="nav-item"
          :class="{ 'is-active': isActive('/invoices') }"
          @click="invoicesClicked"
          title="Facturas"
        >
          <div class="icon-circle">
            <img src="@/assets/images/invoices_icon_off.png" alt="Facturas" class="header_icon" />
          </div>
          <span class="nav-label">Facturas</span>
        </button>

        <button
          class="nav-item"
          :class="{ 'is-active': isActive('/seo') }"
          @click="seoClicked"
          title="SEO"
        >
          <div class="icon-circle">
            <img src="@/assets/images/seo_icon_off.png" alt="SEO" class="header_icon" />
          </div>
          <span class="nav-label">SEO</span>
        </button>

        <button
          class="nav-item logout-btn"
          @click="logoutClicked"
          title="Cerrar sesión"
        >
          <div class="icon-circle logout-icon-circle">
            <img src="@/assets/images/logout_icon.png" alt="Cerrar sesión" class="header_icon" />
          </div>
          <span class="nav-label">Salir</span>
        </button>
      </nav>
    </div>
  </header>

  <TwoButtonPopup 
    :title="twoButtonTitle"
    :message="twoButtonMessage"
    :acceptButton="twoButtonAcceptButton"
    @acceptCallback="logoutConfirmed"
    :cancelButton="twoButtonCancelButton"
    @cancelCallback="twoButtonCancelCallback"
  />
</template>

<script setup>
import { ref } from "vue";
import { useRouter, useRoute } from 'vue-router';
import TwoButtonPopup from './TwoButtonPopup.vue';

const router = useRouter();
const route = useRoute();

const twoButtonTitle = ref("");
const twoButtonMessage = ref("");
const twoButtonAcceptButton = ref("");
const twoButtonCancelButton = ref("");
const loading = ref(false);

const isActive = (path) => {
  return route.path.startsWith(path);
};

const homeClicked = () => {
  router.push('/home');
};

const invoicesClicked = () => {
  router.push('/invoices');
};

const seoClicked = () => {
  router.push('/seo');
};

const walletClicked = () => {
  router.push('/wallet');
};

const couponsClicked = () => {
  router.push('/coupons');
};

const reservationsClicked = () => {
  router.push('/reservations');
};

const privateplansClicked = () => {
  router.push('/privateplans');
};

const plansClicked = () => {
  router.push('/plans');
};

const usersClicked = () => {
  router.push('/users');
};

const logoutClicked = () => {
  twoButtonTitle.value = "Cerrar sesión";
  twoButtonMessage.value = "¿Estás seguro de que deseas cerrar sesión en God?";
  twoButtonAcceptButton.value = "Cerrar sesión";
  twoButtonCancelButton.value = "Cancelar";
};

const logoutConfirmed = async () => {
  twoButtonTitle.value = "";
  loading.value = true;
  try {
    const response = await fetch(process.env.VUE_APP_API_URL+"api/dashboard/auth/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token'),
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id')
      }),
    });

    await response.json();

  } catch (exception) {
    // do nothing
  } finally {
    loading.value = false;
    localStorage.removeItem('user_id');
    localStorage.removeItem('token');
    router.push('/');
  }
};

const twoButtonCancelCallback = () => {
  twoButtonTitle.value = "";
  twoButtonMessage.value = "";
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(47, 72, 88, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: white;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 72px;
  z-index: 999;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.25);
  padding: 0 1.5rem;
}

.header-content {
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity var(--transition-fast);
}

.logo:hover {
  opacity: 0.9;
}

.logo img {
  height: 38px;
  width: auto;
  object-fit: contain;
}

.header_icons_container {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.nav-item {
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  padding: 6px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  color: #CBD5E1;
  transition: all var(--transition-fast);
  position: relative;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.09);
  color: #FFFFFF;
  transform: translateY(-1px);
}

.nav-item.is-active {
  background: rgba(32, 205, 168, 0.16);
  color: var(--primary-color);
  font-weight: 600;
}

.nav-item.is-active::after {
  content: "";
  position: absolute;
  bottom: -4px;
  width: 18px;
  height: 2.5px;
  background-color: var(--primary-color);
  border-radius: 2px;
}

.icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
}

.header_icon {
  height: 22px;
  width: auto;
  transition: transform var(--transition-fast);
}

.nav-item:hover .header_icon {
  transform: scale(1.1);
}

.nav-label {
  font-size: 11px;
  letter-spacing: 0.02em;
}

.logout-btn {
  margin-left: 0.75rem;
  padding-left: 12px;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
}

.logout-btn:hover {
  background: rgba(248, 103, 103, 0.15);
  color: #FCA5A5;
}

@media screen and (max-width: 1160px) {
  .header {
    height: auto;
    padding: 10px 14px;
  }

  .header-content {
    flex-direction: column;
    gap: 10px;
  }

  .logo img {
    height: 32px;
  }

  .header_icons_container {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.2rem;
  }

  .nav-item {
    padding: 4px 7px;
  }

  .nav-label {
    display: none;
  }

  .logout-btn {
    margin-left: 0.25rem;
    border-left: none;
  }
}
</style>
  